import { useState } from "react";
import { useSelector } from "react-redux";
import { businessUnit } from "../../constants/people";
import UserIcon from "../../assets/icons/person.svg";
import GroupIcon from "../../assets/icons/groups.svg";
import CloseIcon from "../../assets/icons/close.svg";
import CopyIcon from "../../assets/icons/content_copy.svg";
import UpdateInfoIcon from "../../assets/icons/person_edit.svg";
import "./EmployeeCard.css";
import InitialsCircle from "../InitialsCircle";

const getBusinessUnitColor = (unit) => {
  const color = businessUnit.find((item) => item.value === unit);
  return color ? color.color : "#000000";
};

// Helper function to safely get value regardless of data structure
const getValue = (field) => {
  if (field === null || field === undefined) return "NA";
  if (typeof field === "object" && field.value !== undefined)
    return field.value;
  return field;
};

const EmployeeCard = ({
  page,
  isExpanded = false,
  data,
  onSelectEmployee,
  userDetails,
  onUpdateInfo,
  employeeSelected,
}) => {
  const [copied, setCopied] = useState(false);
  const userType = useSelector(
    (state) => state.auth?.loginResponse?.body?.role_type,
  );

  const handleCopy = () => {
    navigator.clipboard.writeText(getValue(data?.company_email_id) || "NA");
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return isExpanded ? (
    <div className="emp-card-expanded">
      <div className="emp-com flex flex-col w-full">
        <div className="flex justify-between">
          <div className="emp-id">
            Employee ID #{getValue(data?.employee_id)}
          </div>
          <img
            className="close-icon"
            src={CloseIcon}
            alt="emp-icon"
            onClick={() => onSelectEmployee("")}
          />
        </div>
        <div className="flex items-center">
          <InitialsCircle
            fullName={
              getValue(data?.full_name) === "NA"
                ? getValue(data?.first_name)
                : getValue(data?.full_name)
            }
            size={40}
          />
          <div className="emp-name">
            {getValue(data?.full_name) === "NA"
              ? getValue(data?.first_name)
              : getValue(data?.full_name)}
          </div>
        </div>
        <div
          className="flex grp-com"
          style={{
            backgroundColor: getBusinessUnitColor(
              getValue(data?.business_unit),
            ),
          }}
        >
          <img className="grp-icon" src={GroupIcon} alt="emp-icon" />
          <div className="grp-text">{getValue(data?.business_unit)}</div>
        </div>
        {userType === "HR" && (
          <button className="pf-pr-btn btn mt-2" onClick={() => onUpdateInfo()}>
            <img src={UpdateInfoIcon} alt="" className="mr-2" />
            Update Info
          </button>
        )}
      </div>
      <div className="emp-details w-full">
        {(getValue(data?.company_email_id) && (
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">Email ID</div>
            <div className="flex expand-copy-wrap" onClick={handleCopy}>
              <div className="emp-detail-expand-value flex position-relative">
                {getValue(data?.company_email_id)}
                <img
                  className="filter-icon email-ico"
                  src={CopyIcon}
                  alt="Copy"
                />
                {copied && <div className="tooltip-text">Copied!</div>}
              </div>
            </div>
          </div>
        )) ||
          ""}

        <div className="flex flex-col ">
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">Designation</div>
            <div className="emp-detail-expand-value">
              {getValue(data?.designation)}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">Joining Date</div>
            <div className="emp-detail-expand-value">
              {getValue(data?.date_of_joining)}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">Office Location</div>
            <div className="emp-detail-expand-value">
              {getValue(data?.office_city)}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">Business Unit Head</div>
            <div className="emp-detail-expand-value">
              {getValue(data?.business_unit_head)}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">HRBP Role</div>
            <div className="emp-detail-expand-value">
              {getValue(data?.hrbp_name) +
                " ( " +
                getValue(data?.hrbp_employee_id) +
                " ) "}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">Work Area Code</div>
            <div className="emp-detail-expand-value">
              {getValue(data?.work_area_code_x)}
            </div>
          </div>
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">Office Mobile Number</div>
            <div className="emp-detail-expand-value">
              {getValue(data?.office_mobile_no)}
            </div>
          </div>
          {/* <div className="flex flex-col">
            <div className="emp-detail-expand-text">Assigned Permission</div>
            <div className="emp-detail-expand-value">NA</div>
          </div>
        </div>
        <div className="flex flex-col border-bottom pt-12">
          <div className="expand-subhead">Job</div>
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">Payscale</div>
            <div className="emp-detail-expand-value">NA</div>
          </div>
        </div>
        <div className="flex flex-col pt-12">
          <div className="expand-subhead">Social Security</div>
          <div className="flex flex-col">
            <div className="emp-detail-expand-text">ESIC Number</div>
            <div className="emp-detail-expand-value">NA</div>
          </div> */}
        </div>
      </div>
    </div>
  ) : (
    <div
      className={
        employeeSelected?.employee_id === getValue(data?.employee_id)
          ? "emp-card border-2"
          : "emp-card"
      }
      onClick={() => {
        getValue(userDetails?.full_name) === getValue(data?.full_name)
          ? onSelectEmployee("")
          : onSelectEmployee(data);
      }}
    >
      <div className="emp-com flex flex-col">
        <div className="emp-id">Employee ID #{getValue(data?.employee_id)}</div>
        <div className="flex items-center">
          {/* <img className="emp-icon" src={UserIcon} alt="emp-icon" /> */}
          <InitialsCircle
            fullName={
              getValue(data?.full_name) === "NA"
                ? getValue(data?.first_name)
                : getValue(data?.full_name)
            }
            size={36}
          />
          <div className="emp-name">
            {getValue(data?.full_name) === "NA"
              ? getValue(data?.first_name)
              : getValue(data?.full_name)}
          </div>
        </div>
        <div
          className="flex grp-com"
          style={{
            backgroundColor: getBusinessUnitColor(
              getValue(data?.business_unit),
            ),
          }}
        >
          <img className="grp-icon" src={GroupIcon} alt="emp-icon" />
          <div className="grp-text">{getValue(data?.business_unit)}</div>
        </div>
      </div>
      <div className="emp-details w-full">
        <div className="flex emp-details-item">
          <div className="emp-detail-text">Email ID</div>
          <div className="emp-detail-value">
            {getValue(data?.company_email_id)}
          </div>
        </div>
        <div className="flex emp-details-item">
          <div className="emp-detail-text">Joining Date</div>
          <div className="emp-detail-value">
            {getValue(data?.date_of_joining)}
          </div>
        </div>
        <div className="flex emp-details-item">
          <div className="emp-detail-text">Business Unit</div>
          <div className="emp-detail-value">
            {getValue(data?.business_unit)}
          </div>
        </div>
        <div className="flex emp-details-item">
          <div className="emp-detail-text">Direct Manager</div>
          <div className="emp-detail-value">
            {getValue(data?.direct_manager_name)}
          </div>
        </div>
        <div className="flex emp-details-item">
          <div className="emp-detail-text">Office Location</div>
          <div className="emp-detail-value">{getValue(data?.office_city)}</div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeCard;
